<template>
  <div class="wrapper">
    <Header></Header>
    <div v-if="dingbu1.logo">
      <a
        class="guanggao"
        :href="dingbu1['dirlink']"
        target="_blank"
        v-if="dingbu1['type']&&dingbu1['type']===1"
      >
        <object data type>
          <embed :src="dingbu1['logo']" type style="width:790px;height:100px;">
        </object>
      </a>
      <a class="guanggao" :href="dingbu1['dirlink']" v-else>
        <img :src="dingbu1['logo']" alt>
      </a>
    </div>
    <div class="content-wrap">
      <div class="content-left">
        <div class="seat">
          <span>当前位置：</span>
          <router-link to="/">首页></router-link>
          <span class="coord" v-if="cateTitle" v-text="cateTitle">看山东</span>
          <span v-else>新闻详情</span>
        </div>

        <div class="news-content">
          <span class="title" v-text="newsContent.title"></span>
          <div class="from">
            <span>来自：{{newsContent.origin}}</span>
            <span>作者：{{newsContent.author}}</span>
            <span>发布时间：{{newsContent.create_time}}</span>
          </div>

          <div class="text" v-html="newsContent.content">
            山东省青岛市即墨区因服装批发远近闻名，
            拥有小商品城、服装批发市场、布匹床上用品批发市场等多个批发市场
            。这些市场大多历史悠久、规模大、摊位多，市场监管的压力较大。
            近日，《中国消费者报》记者从即墨区市场监督管理局了解到，
            该局为能更精细地进行市场监管，探索推行了“街长制”，
            发动商户自愿参与市场治理，打造出社会共治、市场共建、环境共享的市场监管新格局。
          </div>
        </div>

        <!--分享链接-->
        <div class="pinglun">
          <div style="color:#999;">分享到：</div>
          <other-share ref="otherShare"></other-share>
        </div>
        <div class="content-foot">
          <div class="comment-wrap">
            <div class="comment-number">
              <span class="number" v-text="count||0"></span> 条评论
            </div>
            <div class="input-wrap">
              <textarea class="comment" v-model="commentContent" placeholder="写下您的评论"></textarea>
              <button class="releace" type="submit" @click="submit">发布</button>
            </div>
            <hr>
            <!--评论详情-->
            <div class="comment-area" v-for="(item,index) in commentMsg" :key="index">
              <div class="comment-title">
                <div>
                  <span v-text="item.nickname"></span>
                  <span v-if="item.is_top!==0" class="top">置顶</span>
                </div>
                <!--用户名-->
                <span v-text="item.create_time"></span>
              </div>
              <div class="comment-info" v-text="item.detail"></div>
              <hr>
            </div>
            <div class="more-comment" @click="moreComment">更多评论></div>
          </div>
        </div>
      </div>

      <div class="content-right">
        <div>
          <NewsModule title="最新" :more="false" :active="false" :info="rightNews.new"></NewsModule>
        </div>
        <div>
          <NewsModule title="监督" :more="false" :active="false" :info="rightNews.top"></NewsModule>
        </div>

        <a :href="art2.dirlink" v-if="art2.type&&art2.type===1">
          <object data type>
            <embed style="width:380px;height:100px;" :src="art2.logo" type>
          </object>
        </a>

        <a class="guanggao2" :href="art2.dirlink" v-else>
          <img style="width:380px;height:100px;" :src="art2.logo" alt>
        </a>

        <a class="guanggao2" :href="art3.dirlink" v-if="art3.type&&art3.type===1">
          <object data type>
            <embed style="width:380px;height:100px;" :src="art3.logo" type>
          </object>
        </a>
        <a class="guanggao2" :href="art3.dirlink" v-else>
          <img style="width:380px;height:100px;" :src="art3.logo" alt>
        </a>
      </div>
    </div>

    <HomeFoot></HomeFoot>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HomeFoot from "@/components/HomeFoot.vue";
import NewsList from "@/components/NewsList.vue";
import NewsModule from "@/components/NewsModule.vue";
import OtherShare from "@/components/OtherShare.vue";

export default {
  name: "article",
  components: {
    Header,
    HomeFoot,
    NewsList,
    NewsModule,
    OtherShare
  },
  data() {
    return {
      id: "",
      complainMessage: "",
      rightNews: "",
      newsContent: "",
      commentContent: "",
      commentMsg: [],
      morePinglun: "",
      count: "",
      commentPage: 1,
      dingbu1: "",
      art2: "",
      art3: "",
      totalPage: "",
      cateTitle: "",
      shareData: {
        url: "",
        title: "",
        pic: "",
        desc: ""
      },
      loading: false
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.getNewsContent();
    }
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.getOtherShare();
  },
  created() {
    this.getNewsContent();
    this.getRightNews();
    this.getGuangGao();

    // 每次刷新页面都跳转到页面顶部
  },
  methods: {
    getGuangGao() {
      this.$get("https://315sd.0532.name/index/index/article_list_ad")
        .then(res => {
          if (res.code === 0) {
            this.dingbu1 = res.data.ad1;
            this.art2 = res.data.ad2;
            this.art3 = res.data.ad3;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分享
    getOtherShare() {
      // 获取分享参数
      let params = {
        type: 1,
        id: this.$route.query.id,
        url: window.location.href.split("#")[0]
      };
      this.$post("/index/mobile/share_other", params).then(res => {
        if (res.code === 0) {
          this.shareData.url = window.location.href;
          this.shareData.title = res.data.share.title;
          this.shareData.pic = res.data.share.imgUrl;
          this.shareData.desc = res.data.share.desc;
          this.$refs.otherShare.init(this.shareData);
        } else {
          this.$layer.toast(res.msg);
        }
      });
    },

    getNewsContent() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;

      // 获取首页跳转时携带的分类id
      this.id = this.$route.query.id;
      this.cateTitle = this.$route.query.cateTitle;

      this.$post("https://315sd.0532.name/api/general/article_detail", {
        id: this.id
      })
        .then(res => {
          if (res.code === 0) {
            this.newsContent = res.data;

            this.readComment();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getRightNews() {
      // 获取首页跳转时携带的分类id
      this.id = this.$route.query.id;
      this.$get("https://315sd.0532.name/api/general/new_hot")
        .then(res => {
          if (res.code === 0) {
            this.rightNews = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //获取评论
    readComment() {
      this.$post("https://315sd.0532.name/index/comment/a_comment_list", {
        id: this.id, //文章ID
        page: this.commentPage
      })
        .then(res => {
          if (res.code === 0) {
            this.totalPage = res.data;
            this.count = res.data.count;
            this.commentMsg = res.data.listData;
            console.log(this.commentMsg, "获取到的评论");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取更多评论
    moreComment() {
      this.commentPage += 1;
      if (this.commentPage > this.totalPage) {
        this.$message("没有更多评论了");
      } else {
        this.$post("https://315sd.0532.name/index/comment/a_comment_list", {
          id: this.id,
          page: this.commentPage
        })
          .then(res => {
            if (res.code === 0) {
              this.morePinglun = res.data.listData;
              if (!this.morePinglun[0]) {
                this.$message("没有更多评论了");
              } else {
                this.commentMsg.push.apply(this.commentMsg, this.morePinglun);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    // 提交评论
    submit() {
      if (this.loading) return
      this.loading = true
      let token = localStorage.getItem("token");
      if (token === "") {
        this.$message({ message: "需要注册才能评论", type: "warning" });
      }
      if (this.commentContent) {
        this.$post("https://315sd.0532.name/index/comment/apost_comment", {
          token: token,
          id: this.id,
          detail: this.commentContent
        })
          .then(res => {
            this.loading = false
            if (res.code === 0) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.commentContent = "";
              this.readComment();
            }
          })
          .catch(err => {
            this.loading = false
            console.log(err);
          });
      } else {
        this.loading = false
        this.$message({
          message: "请输入评论",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.content-wrap {
  /*display: flex;*/
  width: 1200px;
  margin: 32px auto;
  justify-content: space-between;
  overflow: hidden;
}

.guanggao {
  display: block;
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  margin-top: 20px;

  img {
    width: 1200px;
    height: 100px;
  }
}

.guanggao2 {
  width: 380px;
  height: 100px;
  margin: 10px 0;

  img {
    width: 380px;
    height: 100px;
  }
}

.top {
  width: 27px;
  height: 13px;
  background: #d60106;
  font-size: 8px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 255, 255, 1);
  line-height: 10px;
  padding: 1px 2px;
  margin-left: 3px;
}

.coord {
  color: #000000;
  cursor: default;
}

.content-left {
  float: left;
  width: 780px;

  .seat {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-bottom: 40px;

    .seat > span {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
  }
}

.title {
  display: inline-block;
  font-size: 38px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: #666666;
  line-height: 59px;

  width: 800px;
}

.from {
  height: 21px;
  font-size: 17px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  line-height: 21px;
  margin-bottom: 50px;
  margin-top: 15px;
}

.from > span {
  margin-left: 40px;
}

.from > span:first-child {
  margin-left: 0;
}

.text {
  width: 780px;
  min-height: 810px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.text > img {
  max-width: 100%;
}

.content-foot {
  display: flex;
  justify-content: space-between;
  width: 787px;
  margin-top: 46px;
}

.comment-wrap {
  width: 787px;
}

.comment-wrap > hr {
  margin-top: 30px;
  border: 0;
  height: 1px;
  background: #d8d8d8;
}
.pinglun {
  display: flex;
  align-items: center;
  margin-top: 40px;
}
.input-wrap {
  width: 787px;
  overflow: hidden;

  .releace {
    float: right;
    margin-top: 20px;
    padding: 10px 30px;
    background: #294b7f;
    outline: none;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #fff;
    cursor: pointer;
    border-radius: 3px;
  }
}

.comment {
  width: 100%;
  box-sizing: border-box;
  min-height: 76px;
  outline: none;
  -webkit-appearance: none;
  border-radius: 0;
  border: 1px solid #979797;
  line-height: 28px;
  padding: 10px 0;
  font-size: 16px;
  /*border-right: none;*/
  padding-left: 8px;
}

.comment:empty::before {
  color: lightgrey;
  content: attr(placeholder);
}

.content-right {
  margin-top: 60px;
  margin-left: 840px;
}

.content-right > div {
  margin-bottom: 20px;
}

.comment-area {
  width: 787px;
  height: 79px;
  margin-top: 19px;
}

.comment-area > hr {
  border: 0;
  height: 1px;
  background: #d8d8d8;
}

.comment-number {
  color: #a8a8a8;
}

.number {
  height: 29px;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  color: rgba(208, 2, 27, 1);
  line-height: 29px;
}

.comment-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #6b6b6b;
  line-height: 21px;
}

.comment-info {
  margin: 16px 0;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #333333;
  line-height: 21px;
}

.more-comment {
  width: 95px;
  height: 30px;
  background: #f3f3f3;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  line-height: 30px;
  text-align: center;
  margin-left: 332px;
  margin-top: 30px;
  cursor: pointer;
}
</style>
